import React from 'react';
import PropTypes from 'prop-types';

import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';
import SrFlex from 'client/components/SrFlex';
import SrTooltipV2, {
  SR_TOOLTIP_V2_DIRECTION_RIGHT,
} from 'client/components/SrTooltipV2/SrTooltipV2';

const SrPercentTicker = ({ currentPercent, onDecrease, onIncrease, header, min, max, tooltip }) => {
  return (
    <>
      {header && (
        <SrText
          color="blueGreycliff"
          font="greycliff"
          size="16"
          lineHeight="30px"
          weight="800"
          display="block"
          align="center"
        >
          {header}
        </SrText>
      )}
      <SrFlex justify="between" align="center">
        <SrBox position="relative">
          <SrBox
            backgroundImage="url(/images/arrow-circle-grey-down.svg)"
            backgroundColor="#eff0f1"
            backgroundSize="51px"
            backgroundPosition="center"
            backgroundRepeat="no-repeat"
            height="51px"
            width="51px"
            borderRadius="26px"
            cursor="pointer"
            flexShrink="0"
            onClick={onDecrease}
            opacity={currentPercent === min ? '0.3' : null}
          />
          {tooltip && tooltip.direction === 'left' && (
            <SrBox
              position="absolute"
              bottom="67px"
              left="-20px"
              width="326px"
              maxWidth="calc(100vw - 30px)"
            >
              <SrTooltipV2 text={tooltip.text} />
            </SrBox>
          )}
        </SrBox>
        <SrBox marginBottom="10px">
          <SrText
            font="greycliff"
            color="blueGreycliff"
            weight="600"
            fontSize="80px"
            lineHeight="83px"
          >
            {Math.round(currentPercent * 100)}
          </SrText>
          <SrText
            font="greycliff"
            color="blueGreycliff"
            weight="700"
            fontSize="40px"
            lineHeight="83px"
          >
            %
          </SrText>
        </SrBox>
        <SrBox position="relative">
          <SrBox
            backgroundImage="url(/images/arrow-circle-grey-up.svg)"
            backgroundColor="#eff0f1"
            backgroundSize="51px"
            backgroundPosition="center"
            backgroundRepeat="no-repeat"
            height="51px"
            width="51px"
            borderRadius="26px"
            cursor="pointer"
            flexShrink="0"
            onClick={onIncrease}
            opacity={currentPercent === max ? '0.3' : null}
          />
          {tooltip && tooltip.direction === 'right' && (
            <SrBox
              position="absolute"
              bottom="67px"
              right="-20px"
              width="326px"
              maxWidth="calc(100vw - 30px)"
            >
              <SrTooltipV2 text={tooltip.text} direction={SR_TOOLTIP_V2_DIRECTION_RIGHT} />
            </SrBox>
          )}
        </SrBox>
      </SrFlex>
    </>
  );
};

SrPercentTicker.propTypes = {
  currentPercent: PropTypes.number.isRequired,
  onDecrease: PropTypes.func.isRequired,
  onIncrease: PropTypes.func.isRequired,
  header: PropTypes.string,
  tooltip: PropTypes.object,
  min: PropTypes.number.isRequired,
  max: PropTypes.number.isRequired,
};

SrPercentTicker.displayName = 'SrPercentTicker';

export default SrPercentTicker;
